import React from "react";
import { ArrowLeft, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { ThemeToggle } from "@/components/ThemeToggle";

interface DemoModalProps {
  children: React.ReactNode;
  onExit: () => void;
  onReset?: () => void;
  className?: string;
}

export const DemoModal: React.FC<DemoModalProps> = ({
  children,
  onExit,
  onReset,
  className,
}) => {
  return (
    <div className="fixed inset-0 z-50 bg-background">
      <div className="absolute top-4 left-4 right-4 flex justify-between items-center">
        <Button variant="ghost" size="sm" onClick={onExit} className="gap-2">
          <ArrowLeft className="h-4 w-4" />
          Exit Demo
        </Button>
        <div className="flex items-center gap-2">
          {onReset && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onReset}
              className="gap-2"
            >
              <RotateCcw className="h-4 w-4" />
              Reset
            </Button>
          )}
          <ThemeToggle />
        </div>
      </div>
      <div className={cn("h-full w-full overflow-auto pt-16", className)}>
        {children}
      </div>
    </div>
  );
};
